import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IWindow } from '@phdsoft/window';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { DigitalTwinService } from 'src/app/digital-twin/digital-twin.service';
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement';
import { Vector3 } from 'three';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'phdsoft-change-completed-ids-config',
  templateUrl: "./change-completed-ids-config.component.html",
  styleUrls: ["./change-completed-ids-config.component.scss"]
})
export class ChangeCompletedIdsConfigComponent {

  public optionsWindow: IWindow = {
    Position: 'favorite',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'New User',
      Visible: true,
    },
    Footer: {
      ShowCancel: false,
      ShowOk: true,
      Visible: true,
    },
  };


  private _completedIdsElements : Array<WorkableElement>;
  public get completedIdsElements() : Array<WorkableElement> {
    return this._completedIdsElements;
  }
  public set completedIdsElements(v : Array<WorkableElement>) {
    this._completedIdsElements = v;
  }


  private _width: number = 1;
  private _height: number = 1;
  private _depth: number = 1;

  public get width(){
    return this._width
  }
  public set width(v: number){
    this._width = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get height(){
    return this._height
  }
  public set height(v: number){
    this._height = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get depth(){
    return this._depth
  }
  public set depth(v: number){
    this._depth = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }


  public get formatedWidth(){
    return (this.width * 100).toFixed(0)
  }

  public get formatedHeight(){
    return (this.height * 100).toFixed(0)
  }

  public get formatedDepth(){
    return (this.depth * 100).toFixed(0)
  }

  public get dimensions(){
    return new Vector3(this.width, this.height, this.depth)
  }


  constructor(
    public dialogRef: MatDialogRef<ChangeCompletedIdsConfigComponent>,
    private assetManager: AssetManager,
    private digitalTwinService: DigitalTwinService,
  ) {}

  updateBoxDimensions(){
    this.assetManager.updateCriticalAreaBox(this.width, this.height, this.depth)
  }

  submit(){
    this.dialogRef.close()
  }

  onChangeCompletedIdWeb() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'COMPLETEDFULLIDSWEB';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }
  onChangeCompletedIdFlange() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'COMPLETEDFULLIDSFLANGE';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }

  onTargetSelectButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'INSPECCHANGETARGET';
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onTargetSelectButtonClick button clicked!');
  }

  onExecuteChangeButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.setCompletedIds();
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onExecuteChangeButtonClick button clicked! CompletedIds');
  }

  save() {
    this.saveCompletedIds();

    console.log('onStopInspectionChangeButtonClick button clicked!');
  }

  cancel() {
    if(this._completedIdsElements){
      for (const element of this._completedIdsElements) {
        element.currentRenderMaterial = element.defaultMaterial;
      }
    }

    if(this.assetManager.currentFlangeCompletedId != null)
      this.assetManager.currentFlangeCompletedId.currentRenderMaterial = this.assetManager.currentFlangeCompletedId.defaultMaterial

    if(this.assetManager.currentWebCompletedId != null)
      this.assetManager.currentWebCompletedId.currentRenderMaterial = this.assetManager.currentWebCompletedId.defaultMaterial

    console.log('onStopInspectionChangeButtonClick button clicked!');
    this.assetManager.currentWebCompletedId = null
    this.assetManager.currentFlangeCompletedId = null
    this._completedIdsElements = []
    this.assetManager.setFunctionalityModeNone();
  }


  public  setCompletedIds(){
    console.log(this.assetManager.currentWebCompletedId)
    console.log(this.assetManager.currentFlangeCompletedId)
    if(this.assetManager.currentWebCompletedId && this.assetManager.currentFlangeCompletedId){
      if(this.assetManager.currentFlangeCompletedId.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER){
        this.assetManager.currentFlangeCompletedId.properties.General.CompleteStiffenerId = uuid().toString();
        this.assetManager.currentWebCompletedId.properties.General.CompleteStiffenerId = this.assetManager.currentFlangeCompletedId.properties.General.CompleteStiffenerId
      }
      else if(this.assetManager.currentFlangeCompletedId.properties.TypeId === ELEMENTSTYPESIDS.BRACKET){
        this.assetManager.currentFlangeCompletedId.properties.General.CompleteBracketId = uuid().toString();
        this.assetManager.currentWebCompletedId.properties.General.CompleteBracketId = this.assetManager.currentFlangeCompletedId.properties.General.CompleteBracketId
      }

      if(!this._completedIdsElements)
        this._completedIdsElements = []

      if(this._completedIdsElements.findIndex(x => x.Guid === this.assetManager.currentWebCompletedId.Guid) == -1){
        this._completedIdsElements.push(this.assetManager.currentWebCompletedId);
      }

      if(this._completedIdsElements.findIndex(x => x.Guid === this.assetManager.currentFlangeCompletedId.Guid) == -1){
        this._completedIdsElements.push(this.assetManager.currentFlangeCompletedId);
      }

      // await this.digitalTwinService.updatePropertiesList()
    }
  }

  public async saveCompletedIds(){
    if(this._completedIdsElements && this._completedIdsElements.length > 0){
      await this.digitalTwinService.updatePropertiesList(this._completedIdsElements.map(x => x.properties), this._completedIdsElements[0].regionId, this.assetManager.asset.assetInfo.AssetId);

    }
    this.cancel();
    // this._completedIdsElements = []
  }
}

